import { EquipmentsTab } from '@/components/Analysis/shared/EquipmentsTab';
import * as analysisState from '@/components/Analysis/state';
import { SelectedTab } from '@/types';
import { Stack } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';
import { useAtomValue } from 'jotai';
import CommentsContainer from '../CommentDrawer/CommentsContainer';
import { CommentsFallbackMessage } from '../CommentDrawer/CommentsFallbackMessage';
import { FloatingLine, riskTabStyles } from './styles';
import { BasicTabs } from '@/components/shared/BasicTabs';

export const EquipmentDrawer = () => {
  const selectedAssemblyId = useAtomValue(analysisState.selectedAssemblyId);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(SelectedTab.COMPONENT);
  const handleTabChange = useCallback((newTabValue: number) => {
    setSelectedTabIndex(newTabValue);
  }, []);

  const tabs = useMemo(() => {
    return [
      {
        index: SelectedTab.COMPONENT,
        label: 'Equipment info',
        component: <EquipmentsTab changeTab={setSelectedTabIndex} />,
        visibilityPermission: true,
      },
      {
        index: SelectedTab.COMMENTS,
        label: 'Comments',
        component: (
          <>
            {selectedAssemblyId ? (
              <CommentsContainer selectedAssemblyId={selectedAssemblyId} />
            ) : (
              <CommentsFallbackMessage type="selection" />
            )}
          </>
        ),
        visibilityPermission: true,
      },
    ].filter((tab) => tab.visibilityPermission);
  }, [selectedAssemblyId]);

  return (
    <Stack width="100%" overflow="hidden">
      <BasicTabs
        tabs={tabs}
        selectedTab={selectedTabIndex}
        changeTab={handleTabChange}
        tabsStyles={riskTabStyles}
        customSeperator={<FloatingLine />}
        renderingStrategy="eager"
      />
    </Stack>
  );
};
